import { isPlainObject } from '@reduxjs/toolkit';

export const isDeepEqual = <T extends Object, R extends Object>(
    object1: T,
    object2: R,
    skipKeys?: string | string[]
) => {
    const objKeys1 = Object.keys(object1);
    const objKeys2 = Object.keys(object2);

    if (objKeys1.length !== objKeys2.length) return false;

    for (var key of objKeys1) {
        if ((Array.isArray(skipKeys) && skipKeys.includes(key)) || skipKeys === key) {
            continue;
        }

        const value1 = object1[key];
        const value2 = object2[key];

        const isObjects = isPlainObject(value1) && isPlainObject(value2);

        if ((isObjects && !isDeepEqual(value1, value2)) || (!isObjects && value1 !== value2)) {
            return false;
        }
    }
    return true;
};
